// External
import React from "react";
import ReactDOM from "react-dom";

// Internal
import { App } from "./modules";
import "./styles/global.css";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
